// extracted by mini-css-extract-plugin
module.exports = {"articleImage":"article_articleImage__2RJDW","articleContent":"article_articleContent__1Qj7V","leftButtons":"article_leftButtons__-V-0B"};